/** Product API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs, ProductNs} from '@shared/types'

const api = createApi('product')

export const ProductApi = {
  getProductList: () =>
    api.get<ProductNs.Product[]>('list'),
  cancelSubscription: (data: ProductNs.CancelSubscriptionRequest) =>
    api.post<ProductNs.CancelSubscriptionRequest, CommonNs.AnyResponse>('cancel-subscription', data),
  changeProduct: (data: ProductNs.UpdateProductRequest) =>
    api.post<ProductNs.UpdateProductRequest, CommonNs.AnyResponse>('change-product', data),
  changeQuantity: (data: ProductNs.UpdateProductRequest) =>
    api.post<ProductNs.UpdateProductRequest, CommonNs.AnyResponse>('change-quantity', data),
}
